/**
 * Route for `localized-help-center-intercom-backed`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LocalizedHelpCenterIntercomBackedPage } from "../features/localized-help-center-intercom-backed/LocalizedHelpCenterIntercomBackedPage";

export const localizedHelpCenterIntercomBackedRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/localized-help-center-intercom-backed",
	component: LocalizedHelpCenterIntercomBackedPage,
});

export default localizedHelpCenterIntercomBackedRoute;
